import React from 'react';
import { motion } from 'framer-motion';
export function PricingSection() {
  return <section className="py-10 md:py-14 px-4 md:px-8 bg-navy-900 relative overflow-hidden" data-id="element-210">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-211"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-12" data-id="element-213">
          <h3 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-214">
            Una Inversión Que Se Paga Sola En La Primera Semana
          </h3>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-215">
            El valor total de esta transformación es de{' '}
            <strong className="text-white" data-id="element-216">$37 USD.</strong>
            <br data-id="element-217" />
            <br data-id="element-218" />
            Pero porque creemos que el cambio financiero real debe ser accesible
            para quienes están listos para actuar, hoy puedes asegurar tu
            transformación por una única inversión de:
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-800 border border-gold/40 rounded-2xl overflow-hidden max-w-2xl mx-auto mb-12 shadow-[0_0_40px_rgba(212,160,23,0.15)]" data-id="element-219">
          <div className="flex flex-col md:flex-row border-b border-gray-700" data-id="element-220">
            <div className="p-6 md:w-1/2 bg-navy-900/50 flex items-center" data-id="element-221">
              <span className="text-gray-400 font-medium" data-id="element-222">
                Valor real del sistema
              </span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end" data-id="element-223">
              <span className="text-2xl text-red-500 line-through font-bold opacity-80" data-id="element-224">
                $37 USD
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row border-b border-gray-700 bg-gold/10" data-id="element-225">
            <div className="p-6 md:w-1/2 flex items-center gap-3" data-id="element-226">
              <span className="text-gold font-bold text-xl" data-id="element-227">
                Tu inversión hoy
              </span>
              <span className="inline-block bg-red-500/20 text-red-400 text-xs font-bold px-3 py-1 rounded-full border border-red-500/30" data-id="element-228">
                83% OFF
              </span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end" data-id="element-229">
              <span className="text-4xl md:text-5xl text-gold font-bold" data-id="element-230">
                $6.36 USD
              </span>
            </div>
          </div>

          <div className="flex flex-col md:flex-row" data-id="element-231">
            <div className="p-6 md:w-1/2 bg-navy-900/50 flex items-center" data-id="element-232">
              <span className="text-gray-300 font-medium" data-id="element-233">Lo que obtienes</span>
            </div>
            <div className="p-6 md:w-1/2 flex items-center justify-end text-right" data-id="element-234">
              <span className="text-white font-bold" data-id="element-235">
                Más de 6 veces el valor de tu inversión
              </span>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-236">
          <p className="text-xl text-gray-400 italic font-serif" data-id="element-237">
            Al precio de un café puedes dejar de perder cientos o miles de
            dólares en ingresos por bloqueos que no ves.
          </p>
        </motion.div>
      </div>
    </section>;
}